import React, { useEffect, useState } from 'react'
import { ParamType, StructureType } from '../../../pages/ClientPanel/Certificates/CreateParam'
import ModalTest from '../../BaseModal'
import axios from 'axios'
import { HiddenCheckbox, StyledCheckbox } from '../../FieldManager/style'
import { BottomDiv, ButtonContainer, Button, CloseDiv, ContainerOfModal, Header, HeaderTitle } from '../../styles/modal-style'
import { ColumnLI, ColumnsList, ContainerOfColumns, ColumnInfoDiv, ColumnDesc, ColumnName, Select } from './style'
import { X } from 'lucide-react'

interface PropsType {
  onClose: () => void
  param: ParamType
  setParam: React.Dispatch<React.SetStateAction<ParamType>>
  clickedStructure: number
}

export interface ColumnType {
  id: number
  name: string
  structureId: number
  min?: number
  max?: number
  unitOfMeasurement?: {id:number, name:string}[]
  unitUsed?: {id:number, name:string}
}

const EditStructureModal:React.FC<PropsType> = ({ onClose, param, setParam, clickedStructure }) => {
  const [ previewStructure, setPreviewStructure ] = useState<StructureType>(param.structures.find((item) => item.id === clickedStructure)!)
  const [ columns, setColumns ] = useState<ColumnType[]>([])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_CERTIFICATES_BASE_URL}/column/${clickedStructure}`)
      .then((response) => {
        if(response.data) setColumns(response.data)
      })
      .catch((error) => {
        console.error(error)
      })
  }, [])

  const handleChangeUnit = (e: React.ChangeEvent<HTMLSelectElement>, column: ColumnType) => {
    setPreviewStructure((prev) => {
      return {
        ...prev,
        columns: prev.columns.map((col) => {
          if(col.id !== column.id) return col
          return {
            ...col,
            unitUsed: {
              id: Number(e.target.value),
              name: column.unitOfMeasurement?.find(unit => unit.id === Number(e.target.value))?.name || ''
            }
          }
        })
      }
    })
  }

  const handleSelectColumn = (column:ColumnType) => {
    setPreviewStructure(prev => {
      const exists = prev.columns.some(col => col.id === column.id)
      const newColumns = exists ? prev.columns.filter(col => col.id !== column.id) : [...prev.columns, column]

      return {
        ...prev,
        columns: newColumns
      }
    })
  }

  const handleSave = () => {
    setParam(prev => ({
      ...prev,
      structures: prev.structures.map(item => item.id === clickedStructure ? {
        ...previewStructure,
        columns: previewStructure.columns.map(c => {
          const {unitOfMeasurement, ...rest} = c
          return rest
        })
      } : item)
    }))
    onClose()
  }
  
  return (
    <ModalTest>
      <ContainerOfModal>
        <Header>
          <HeaderTitle>{previewStructure.name}</HeaderTitle>
          <CloseDiv onClick={onClose}> <X size={20} /> </CloseDiv>
        </Header>
        <ContainerOfColumns>
          <ColumnsList>
            {columns.map((column) => (
              <>
              <ColumnLI key={column.id}>
                <HiddenCheckbox
                  checked={previewStructure.columns.some(col => col.id === column.id) || false}
                  onClick={() => handleSelectColumn(column)}
                />
                <StyledCheckbox checked={previewStructure.columns.some(col => col.id === column.id) || false} onClick={() => handleSelectColumn(column)} />
                <ColumnInfoDiv onClick={() => handleSelectColumn(column)}>
                  <ColumnName>{column.name}</ColumnName>
                  {/* <ColumnDesc>Unidade de medida: %</ColumnDesc> */}
                </ColumnInfoDiv>
                <Select onChange={(e) => handleChangeUnit(e, column)} value={column.unitUsed?.id} disabled={previewStructure.columns.some(col => col.id === column.id) ? false : true}>
                  <option value=''>-</option>
                  {column.unitOfMeasurement?.map((item: {id:number, name:string}) => (
                    <option key={item.id} value={item.id}>{item.name}</option>
                  ))}
                </Select>
              </ColumnLI>
              </>
            ))}
          </ColumnsList>
        </ContainerOfColumns>
        <BottomDiv>
          <ButtonContainer>
            <Button onClick={onClose} className='cancel'>Cancelar</Button>
            <Button onClick={handleSave}>Salvar estrutura</Button>
          </ButtonContainer>
        </BottomDiv>
      </ContainerOfModal>
    </ModalTest>
  )
}

export default EditStructureModal